import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: '/identity/login', pathMatch: 'full' },
  {path:'identity',loadChildren:()=>import('./features/identity/identity.module').then(x=>x.IdentityModule)},
  {path:'home',loadChildren:()=>import('./features/home/home.module').then(x=>x.HomeModule)},
  {path:'emergency',loadChildren:()=>import('./features/emergency/emergency.module').then(x=>x.EmergencyModule)},
  {path:'vehicle',loadChildren:()=>import('./features/vehicle/vehicle.module').then(x=>x.VehicleModule)},
  {path:'personaldoc',loadChildren:()=>import('./features/personaldoc/personaldoc.module').then(x=>x.PersonaldocModule)},
  {path:'address',loadChildren:()=>import('./features/address/address.module').then(x=>x.AddressModule)},
  {path:'userprofile',loadChildren:()=>import('./features/userprofile/userprofile.module').then(x=>x.UserprofileModule)},
  {path:'meeting',loadChildren:()=>import('./features/meeting/meeting.module').then(x=>x.MeetingModule)},
  {path:'trip',loadChildren:()=>import('./features/trip/trip.module').then(x=>x.TripModule)},
  {path:'finance',loadChildren:()=>import('./features/finance/finance.module').then(x=>x.FinanceModule)},
  {path:'financebalance',loadChildren:()=>import('./features/financebalance/financebalance.module').then(x=>x.FinancebalanceModule)},
  {path:'product',loadChildren:()=>import('./features/product/product.module').then(x=>x.ProductModule)},
  {path:'shopping',loadChildren:()=>import('./features/shopping/shopping.module').then(x=>x.ShoppingModule)},
  {path:'report',loadChildren:()=>import('./features/report/report.module').then(x=>x.ReportModule)},
  {path:'motoclub',loadChildren:()=>import('./features/motoclub/motoclub.module').then(x=>x.MotoclubModule)},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
